import { render, staticRenderFns } from "./CustomChecked.vue?vue&type=template&id=2ed540fb&scoped=true"
import script from "./CustomChecked.vue?vue&type=script&lang=js"
export * from "./CustomChecked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed540fb",
  null
  
)

export default component.exports